import { createSlice } from "@reduxjs/toolkit";
import { getGames } from "./thunks";
import { RootState } from "..";
import { IGame } from "../../entities/games";


interface GamesState {
  games: IGame[]
  loading: boolean,
  loadingError: boolean,
  /** When the last load failed or came back empty — getGames waits before trying again. */
  lastFailedAt: number | null,
}

const initialState: GamesState = {
  games: [],
  loading: false,
  loadingError: false,
  lastFailedAt: null,
}

export const gamesSlice = createSlice({
  name: "games",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getGames.pending, (state) => {
      state.loading = true;
      state.loadingError = false;
    })
    builder.addCase(getGames.fulfilled, (state, action) => {
      state.games = action.payload;
      state.loading = false;
      if (action.payload.length === 0) {
        state.loadingError = true;
        state.lastFailedAt = Date.now();
      } else {
        state.lastFailedAt = null;
      }
    })
    builder.addCase(getGames.rejected, (state) => {
      state.loading = false;
      state.loadingError = true;
      state.lastFailedAt = Date.now();
    })
  },
});

// export const { } = gamesSlice.actions;

export const selectGames = (state:RootState) => state.games 

export default gamesSlice.reducer;
